import React from "react";
import { FaClock, FaUserTie, FaMoneyBillWave } from "react-icons/fa";
import "./WhyChooseUs.css"; // apni CSS alag file mai rakhiyo

const Whychoose = () => {
    return (
        <section className="why-choose-us" id="why-choose-us">
            <div className="container">
                <h2 className="section-title">Why Choose Us</h2>
                <p className="section-subtitle">
                    We are committed to providing exceptional travel services with a focus on
                    safety, comfort, and reliability.
                </p>

                <div className="features-container">
                    <div className="feature-item">
                        <div className="feature-icon">
                            <FaClock />
                        </div>
                        <h3 className="feature-title">24/7 Availability</h3>
                        <p className="feature-description">
                            Our services are available round the clock to ensure you can travel whenever you need.
                        </p>
                    </div>

                    <div className="feature-item">
                        <div className="feature-icon">
                            <FaUserTie />
                        </div>
                        <h3 className="feature-title">Professional Drivers</h3>
                        <p className="feature-description">
                            Our drivers are experienced, well-trained, and committed to providing safe and comfortable journeys.
                        </p>
                    </div>

                    <div className="feature-item">
                        <div className="feature-icon">
                            <FaMoneyBillWave />
                        </div>
                        <h3 className="feature-title">Competitive Rates</h3>
                        <p className="feature-description">
                            We offer transparent pricing with no hidden charges and competitive rates for all our services.
                        </p>
                    </div>

                    <div className="feature-item">
                        <div className="feature-icon">
                            <FaUserTie />
                        </div>
                        <h3 className="feature-title">Trusted Experience</h3>
                        <p className="feature-description">
                            With years of service, we have built trust by delivering safe and comfortable journeys every time.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Whychoose;
